import React from "react";
import "./ReviewsTab.css";

export default function ReviewsTab() {
  return <div className="review-tab">ReviewsTab</div>;
}
